import styled from "styled-components";

export const Wrap = styled.span<{ margin?: string }>`
  margin: ${({ margin }) => margin};
`;
export const UIImage = styled.img`
  float: left;
`;
